import { LeaveAnalytics } from 'components/leave-management/leave-analytics/LeaveAnalytics'
import { TABLE_LEAVE_ANALYTICS } from 'configs/leave-management/configTableLeaveAnalytics'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_LEAVE_ANALYTICS } from 'services/apiLeaveAnalytics'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import moment from 'moment/moment'

const FILTER_PARAMS = ['year', 'leave_ids', 'company_ids', 'department_ids', 'division_ids', 'sub_division_ids']

export const LeaveAnalyticsContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const defaultQuery = {
        page: 1,
        limit: 50,
        search: '',
        year: moment().get('year')
    }
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : defaultQuery
    const [selectedItems, setSelectedItems] = useState([])
    const [queryFilter, setQueryFilter] = useState(null)
    const [toastMessage, setToastMessage] = useState('')
    const [modal, setModal] = useState({
        limit: false,
        export: false,
        toast: false,
    })
    const { data: leaveAnalyticList, fetching: getLeaveAnalyticList, isLoading } = useFetch(API_LEAVE_ANALYTICS.LIST)
    const { fetching: exportLeaveAnalytics } = useFetch(API_LEAVE_ANALYTICS.EXPORT)

    useEffect(() => {
        const newQuery = { ...query }
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.slice(1, 6).includes(key) ? item?.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        fetchLeaveAnalyticsList(newQuery)
    }, [location.search])

    const onSetModal = (item) => {
        setModal((prev) => ({ ...prev, ...item }))
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchLeaveAnalyticsList = (item = { ...query, ...queryFilter }) => {
        getLeaveAnalyticList(item)
    }

    const onExport = () => {
        const combineObj = { ...query, ...queryFilter }
        const { page, limit, ...dataFilterRest } = combineObj
        const payload = { ...dataFilterRest, data: selectedItems }
        exportLeaveAnalytics(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Leave-Analytics-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setToastMessage(`Anda berhasil export data analytics leave`)
            onSetModal({ export: false, toast: true })
        })
    }

    const props = {
        dataAnalyticsLeave: leaveAnalyticList?.data,
        configTable: TABLE_LEAVE_ANALYTICS,
        isLoading,
        query,
        selectedItems,
        modal,
        queryFilter,
        toastMessage,
        onChangeQuery,
        setSelectedItems,
        onExport,
        onSetModal,
    }

    return <LeaveAnalytics {...props} />
}
